<template>
  <div>
    <div
      class="text-h3 font-medium"
      :class="$store.state.mobile ? '' : 'mt-4'"
    >
      <template v-if="$store.getters.languageGetter === '1'">
        أفضله
      </template>
      <template v-else>
        My Favorite
      </template>
    </div>
    <v-row
      v-if="loading"
      class="text-center"
    >
      <v-col
        v-for="i in 12"
        :key="i"
        :cols="$store.state.mobile ? 6 : 2"
      >
        <div :class="$store.state.mobile ? '' : 'px-4'">
          <v-skeleton-loader
            type="image"
          />
        </div>
        <v-skeleton-loader
          type="list-item-two-line"
        />
      </v-col>
    </v-row>
    <v-row v-else-if="favoriteList.items.length">
      <v-col
        v-for="item in favoriteList.items"
        :key="item.id"
        :cols="$store.state.mobile ? 6 : 2"
      >
        <div :class="$store.state.mobile ? '' : 'py-3'">
          <v-card
            elevation="0"
            tile
          >
            <v-card
              outlined
              tile
              :to="{name: 'GoodsDetail', params: {id: item.goodId}}"
            >
              <v-img
                class="img-hover grey lighten-5"
                aspect-ratio="1"
                contain
                :src="item.image + '?x-oss-process=image/resize,m_mfit,w_375,h_375'"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey"
                    />
                  </v-row>
                </template>
              </v-img>
            </v-card>
          </v-card>
          <div class="text-center">
            <div class="text-h6  mt-2 text-truncate">
              <router-link
                :to="{name: 'GoodsDetail', params: {id: item.goodId}}"
              >
                {{ $store.getters.languageGetter === '1' ? item.dnames : item.dnamesEn }}
              </router-link>
            </div>
            <div
              v-if="$store.state.usedCountry"
              class="text-h6 font-medium"
            >
              <div class="black--text d-flex align-center justify-center">
                <span
                  class="text-h4 me-2"
                >{{ $store.getters.countryGetter.currency }}{{ (priceRate(item) * $store.getters.rebateGetter / 100).toFixed(2) }}</span>
                <span :class="$store.getters.rebateGetter < 100 ? 'text-decoration-line-through grey--text' : 'd-none'">{{ $store.getters.countryGetter.currency }}{{ priceRate(item).toFixed(2) }}</span>
              </div>
            </div>
          </div>
          <v-row
            no-gutters
            class="py-2"
          >
            <v-col>
              <v-btn
                color="primary"
                depressed
                dark
                x-small
                tile
                fab
                block
                :to="{name: 'GoodsDetail', params: {id: item.goodId}}"
              >
                <v-icon size="18">
                  mdi-cart-outline
                </v-icon>
              </v-btn>
            </v-col>
            <v-col cols="auto">
              <v-btn
                color="grey"
                depressed
                dark
                x-small
                tile
                fab
                class="px-0"
                @click="setGoodsFavorite(item.goodId)"
              >
                <v-icon size="18">
                  mdi-delete-outline
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col cols="12">
        <div class="text-center">
          <v-pagination
            v-if="length"
            v-model="page"
            page-aria-label="Page"
            previous-aria-label="PrevPage"
            next-aria-label="NextPage"
            wrapper-aria-label="Pagination"
            current-page-aria-label="CurrentPage"
            :length="length"
            :total-visible="7"
            @input="changePagination"
          />
        </div>
      </v-col>
    </v-row>
    <div
      v-else
      class="grey--text text-center py-4"
    >
      <template v-if="$store.getters.languageGetter === '1'">
        لا يوجد شيء هنا
      </template>
      <template v-else>
        There is nothing here
      </template>
    </div>
    <v-divider :class="$store.state.mobile ? 'mt-6' : ''" />
    <v-row>
      <v-col cols="12">
        <tab-goods
          :outlined="false"
          :menus="[0,-1,2]"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import TabGoods from '@/components/TabGoods.vue';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'UserFavoriteList',
  components: {
    TabGoods,
  },
  data() {
    return {
      loading: false,
      page: 1,
    };
  },
  computed: {
    ...mapState('center', ['favoriteList']),
    length() {
      return Math.ceil((this.favoriteList.totalItem ? this.favoriteList.totalItem : 0) / 10);
    },
  },
  created() {
    this.loadPageData();
  },
  methods: {
    ...mapActions('center', ['getFavoriteListAsync']),
    ...mapActions('goods', ['setGoodsUnfavoriteAsync']),
    loadPageData() {
      this.loading = true;
      this.getFavoriteListAsync({ p: this.page, pageSize: 10 }).then(() => {
        this.page = +this.favoriteList.currentPage;
      }).finally(() => {
        this.loading = false;
      });
    },
    setGoodsFavorite(id) {
      this.$store.commit('SET_MINI_LOADING');
      this.setGoodsUnfavoriteAsync({ goodId: id }).then(() => {
        this.getFavoriteListAsync();
      }).finally(() => {
        this.$store.commit('SET_MINI_LOADING');
      });
    },
    changePagination() {
      this.loadPageData();
    },
    priceRate(item) {
      return (+item.countryPrice[this.$store.getters.countryGetter.id] * +this.$store.getters.countryGetter.rate);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
